



























































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Thumbs, Swiper } from 'swiper'
import { mdiChevronLeft, mdiChevronRight, mdiClose } from '@mdi/js'
import { IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'
import 'swiper/swiper.scss'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentImage from '~/components/images/image.vue'

Swiper.use([Thumbs])

@Component({
  components: {
    ComponentImage,
    ComponentFormButtonIcon,
    ComponentImageGallery: () => import('~/components/images/gallery.vue'),
  },
})
export default class ComponentReviewsPhotos extends Vue {
  @Prop({ type: Array, default: () => [] }) private items!: IImageVariants[]

  private swiper!: Swiper
  private $style!: IStyle

  private icons = {
    mdiChevronLeft,
    mdiChevronRight,
    mdiClose,
  }

  private get isShowNavigation() {
    return this.items.length > 6
  }

  private isPhotoPopup = false

  private mounted() {
    const smallPhotoContainer: HTMLElement = this.$refs
      .smallPhotoContainer as HTMLElement

    if (smallPhotoContainer) {
      this.swiper = new Swiper(smallPhotoContainer, {
        touchMoveStopPropagation: true,
        slidesPerView: 'auto',
        watchSlidesProgress: true,
        spaceBetween: 8,
        watchSlidesVisibility: true,
      })

      this.swiper.on('slideChange', () => {
        this.updatedSwiperParams()
      })
    }
  }

  private slidePrev() {
    this.swiper.slidePrev()
  }

  private slideNext() {
    this.swiper.slideNext()
  }

  private updatedSwiperParams(): void {
    this.isBeginning = this.swiper.isBeginning
    this.isEnd = this.swiper.isEnd
  }

  private isBeginning = true
  private isEnd = false

  private get classSwiperArrowLeft() {
    return {
      [this.$style.arrowDisable]: this.isBeginning,
    }
  }

  private get classSwiperArrowRight() {
    return {
      [this.$style.arrowDisable]: this.isEnd,
    }
  }

  private photoStart = 0

  private photoPopupToggle(state: boolean = false, start: number = 0) {
    this.isPhotoPopup = state
    this.photoStart = start
  }
}
